import { Card, Field, Text, Layout } from '@loadsmart/miranda-react'

import { type ShipmentContainer } from '../domain/ShipmentContainer'
import {
  formatContainerSize,
  formatNonRequiredContainerField,
} from '../presenters/ContainerPresenter'

export function RailContainerDetails({ container }: { container?: ShipmentContainer }) {
  if (!container) {
    return null
  }

  return (
    <Card>
      <Card.Title>Container Details</Card.Title>
      <Card.Divider />
      <Card.Body>
        <Layout.Grid columnGap="spacing-12" rowGap="spacing-6" minColumnWidth="160px">
          <Field>
            <Field.Label>Container number</Field.Label>
            <Text variant="body-md">{container.containerNumber}</Text>
          </Field>
          <Field>
            <Field.Label>Booking number</Field.Label>
            <Text data-testid="booking-number" variant="body-md">
              {formatNonRequiredContainerField(container.bookingNumber)}
            </Text>
          </Field>
          <Field>
            <Field.Label>Container size</Field.Label>
            <Text variant="body-md">{formatContainerSize(container.containerSize)}</Text>
          </Field>
        </Layout.Grid>
      </Card.Body>
    </Card>
  )
}
